"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIndexedDBStorageFactory = void 0;
exports.setStorageProviderFactory = setStorageProviderFactory;
exports.resetStorageProviderFactory = resetStorageProviderFactory;
exports.useLocalStorage = useLocalStorage;
var react_1 = require("react");
var solana_headless_adapter_base_1 = require("@hermis/solana-headless-adapter-base");
var defaultStorageFactory = function (key, defaultValue) {
    return (0, solana_headless_adapter_base_1.createLocalStorageUtility)(key, defaultValue);
};
var globalStorageFactory = defaultStorageFactory;
/**
 * Set a custom storage provider factory to be used by all useLocalStorage hooks
 *
 * @param factory Custom storage provider factory
 */
function setStorageProviderFactory(factory) {
    globalStorageFactory = factory;
}
/**
 * Reset the storage provider factory to the default localStorage implementation
 */
function resetStorageProviderFactory() {
    globalStorageFactory = defaultStorageFactory;
}
/**
 * Hook for accessing and updating persistent storage
 *
 * This hook allows for persistent state across sessions using the configured
 * storage provider (localStorage by default).
 *
 * @param key Storage key
 * @param defaultState Default state if key doesn't exist
 * @param customStorageFactory Optional custom storage factory for this specific instance
 * @returns [state, setState] tuple
 */
function useLocalStorage(key, defaultState, customStorageFactory) {
    var _this = this;
    var storageFactory = customStorageFactory || globalStorageFactory;
    var storageProviderRef = (0, react_1.useRef)(storageFactory(key, defaultState));
    var _a = (0, react_1.useState)(defaultState), state = _a[0], setState = _a[1];
    var _b = (0, react_1.useState)(true), loading = _b[0], setLoading = _b[1];
    var isFirstRenderRef = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        var mounted = true;
        var loadInitialValue = function () { return __awaiter(_this, void 0, void 0, function () {
            var storedValue, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setLoading(true);
                        return [4 /*yield*/, storageProviderRef.current.get()];
                    case 1:
                        storedValue = _a.sent();
                        if (mounted) {
                            setState(storedValue);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error reading from storage for key ".concat(key, ":"), error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        if (mounted) {
                            setLoading(false);
                            isFirstRenderRef.current = false;
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadInitialValue();
        return function () {
            mounted = false;
        };
    }, [key]);
    (0, react_1.useEffect)(function () {
        if (isFirstRenderRef.current) {
            return;
        }
        var saveValue = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, storageProviderRef.current.set(state)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Error writing to storage for key ".concat(key, ":"), error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        saveValue();
    }, [key, state]);
    return [state, setState, loading];
}
/**
 * Example of creating an IndexedDB storage provider factory
 * This is a simplified example - a real implementation would need more robust error handling
 */
var createIndexedDBStorageFactory = function (dbName, storeName) {
    var dbPromise = null;
    var initDB = function () {
        if (!dbPromise) {
            dbPromise = new Promise(function (resolve, reject) {
                var request = indexedDB.open(dbName, 1);
                request.onerror = function (event) {
                    reject(new Error('Failed to open IndexedDB'));
                };
                request.onsuccess = function (event) {
                    resolve(request.result);
                };
                request.onupgradeneeded = function (event) {
                    var db = request.result;
                    if (!db.objectStoreNames.contains(storeName)) {
                        db.createObjectStore(storeName);
                    }
                };
            });
        }
        return dbPromise;
    };
    return function (key, defaultValue) {
        initDB();
        return {
            get: function () {
                return __awaiter(this, void 0, Promise, function () {
                    var db_1, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, dbPromise];
                            case 1:
                                db_1 = _a.sent();
                                return [2 /*return*/, new Promise(function (resolve, reject) {
                                        var transaction = db_1.transaction(storeName, 'readonly');
                                        var store = transaction.objectStore(storeName);
                                        var request = store.get(key);
                                        request.onerror = function () { return reject(new Error("Error reading from IndexedDB for key ".concat(key))); };
                                        request.onsuccess = function () {
                                            resolve(request.result === undefined ? defaultValue : request.result);
                                        };
                                    })];
                            case 2:
                                error_3 = _a.sent();
                                console.error("Error reading from IndexedDB for key ".concat(key, ":"), error_3);
                                return [2 /*return*/, defaultValue];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
            set: function (value) {
                return __awaiter(this, void 0, Promise, function () {
                    var db_2, error_4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, dbPromise];
                            case 1:
                                db_2 = _a.sent();
                                return [2 /*return*/, new Promise(function (resolve, reject) {
                                        var transaction = db_2.transaction(storeName, 'readwrite');
                                        var store = transaction.objectStore(storeName);
                                        var request = value === null
                                            ? store.delete(key)
                                            : store.put(value, key);
                                        request.onerror = function () { return reject(new Error("Error writing to IndexedDB for key ".concat(key))); };
                                        request.onsuccess = function () { return resolve(); };
                                    })];
                            case 2:
                                error_4 = _a.sent();
                                console.error("Error writing to IndexedDB for key ".concat(key, ":"), error_4);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        };
    };
};
exports.createIndexedDBStorageFactory = createIndexedDBStorageFactory;
